












import Vue from 'vue'
import ImagemDeTabela from '@/components/ui/ImagemDeTabela.vue'
import Almodelogo from '@/assets/almode_256x181.png'
import type { ResumoDaVenda } from '@/models'

const CANAL_ALMODE = '00000000-0000-0000-0000-000000000000'

export default Vue.extend({
	name: 'CanalDeVendasGrid',
	components: { ImagemDeTabela },
	props: {
		params: {
			type: Object as () => any,
			required: true,
		},
	},
	computed: {
		venda(this: any): ResumoDaVenda {
			return (this.params?.data || {}) as ResumoDaVenda
		},

		canal(this: any) {
			return this.venda.canalDeVendas || null
		},

		nomeCanal(this: any): string {
			if (this.isGroupRow || this.isPinnedTotal) return '' 
			return this.canal?.nome || 'Imagem não encontrada'
		},

		temCanal(this: any): boolean {
			return !!this.canal
		},

		srcImagem(this: any): string | null {
			if (!this.temCanal) return null

			if (this.canal.id === CANAL_ALMODE) {
				return Almodelogo
			}

			return this.canal.imageURL || null
		},

		textoSemImagem(this: any): string {
			if (this.isGroupRow || this.isPinnedTotal) return ''  
			if (!this.temCanal || !this.srcImagem) {
				return 'Imagem não encontrada'
			}
			return this.nomeCanal
		},

		altTexto(this: any): string {
			return this.nomeCanal
		},

		isGroupRow(this: any): boolean {
			return !!this.params?.node?.group 
		},
		
		isPinnedTotal(this: any): boolean {
			return this.params?.node?.rowPinned === 'bottom' && this.venda?.isTotalRow === true
		},
	},
})
